import { useTheme } from '@ori-ui/mui';
import { useMemo } from 'react';

import { useTopAreaStore } from '../stores/TopAreaStore';
import { useCategoryColors } from './useCategoryColors';
import { usePageTypeColors } from './usePageTypeColors';

export const useBannerColors = () => {
  const { bannerHeadLineColor } = useTopAreaStore();
  const { palette } = useTheme();
  const categoryColors = useCategoryColors();
  const pageTypeColors = usePageTypeColors();
  const defaultColors = useMemo(
    () => ({
      backgroundColor: palette.common.white,
      color: bannerHeadLineColor || palette.common.black,
    }),
    [bannerHeadLineColor, palette.common.black, palette.common.white],
  );

  return categoryColors ?? pageTypeColors ?? defaultColors;
};
